import React, { useEffect, useState } from 'react';
import { Text, DefaultButton, IPanelStyles, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, IDropdownOption, ISeparator, ISeparatorProps } from '@fluentui/react';
import { IChoiceField, IField, IRuoloUor, ITextField, IUor, IUser, IUserField, IUserNotifications } from '../../shared/interfaces';
import DynamicForm from '../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import rolesService from '../../services/roles.service';
import { RootState } from '../../store';
import { connect, ConnectedProps } from 'react-redux';
import { RoleContext, Visibility_Type, Visibility_Type_Label } from '../../shared/enums';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { toastRef } from '../Layout/Layout';

const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}

const mapState = (state: RootState) => ({
    allRoles: state.sessionReducer.allRoles,

})
const mapDispatch = {

}
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditUserProps {
    loading?: boolean
    extraCssClass?: string
    selectedUor?: IUor
    selectedPersona?: IUser
    peopleList: IUser[]
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (user: IUser) => void
    onDismiss: () => void
}

type Props = AddEditUserProps & PropsFromRedux

const AddEditUser: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [rolesOptions, setRolesOptions] = useState<IDropdownOption[]>([]);


    useEffect(() => {

        resetFields();
        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen)

    }, [props.panelIsOpen]);

    useEffect(() => {

        resetFields();

    }, [props.selectedPersona]);

    useEffect(() => {

        let _rolesOptions = props.allRoles ? props.allRoles.reduce((a: any[], o) => (o.context === RoleContext.Uor && a.push({ text: o.nome, key: o.id }), a), []) : [];
        setRolesOptions(_rolesOptions);

    }, [props.allRoles]);

    useEffect(() => {

        if (rolesOptions.length > 0) {
            resetFields();
        }

    }, [rolesOptions]);


    const resetFields = () => {
        let personaReadOnly = false;
        let personaValue: any[] = [];
        let visibilityValue: any[] = [];
        let attachmentValue;

        if (props.selectedPersona && props.selectedUor) {
            let personaSelezionata = props.selectedPersona;
            personaReadOnly = true;
            personaValue.push({
                key: personaSelezionata.userPrincipalName,
                imageUrl: personaSelezionata.imageUrl,
                imageInitials: personaSelezionata.initials,
                text: personaSelezionata.displayName,
                secondaryText: personaSelezionata.userPrincipalName,
                showSecondaryText: true,
                hidePersonaDetails: false,
                user: personaSelezionata
            });
        }

        let ruoloValue;
        if (props.selectedPersona && props.selectedPersona.ruoliUorContext && props.selectedUor) {
            let ruoliPersona = [...props.selectedPersona.ruoliUorContext];
            let uorSelezionata = { ...props.selectedUor };

            let ruoloPersonaInCurrentUor = ruoliPersona.find(el => el.uorId === uorSelezionata.id);

            ruoloValue = ruoloPersonaInCurrentUor?.ruoloId;
        }

        if (props.selectedPersona && props.selectedPersona.userNotification && props.selectedUor) {
            let userNotification = props.selectedPersona.userNotification;
            visibilityValue = userNotification.map(el => el.notificationContext);

            //prendo solo il primo perchè la configurazione è uguale per tutti
            let attachment = userNotification.find(el => el.uorId == props.selectedUor?.id)?.attachment;
            attachmentValue = attachment;
        }

        //ricreo i fields a partire da initialFields e aggiungo le options per il field ruolo
        let newFields = [
            {
                displayName: "Utente",
                internalName: "utente",
                sharepointType: "User",
                controlType: "autocompleteUser",
                required: true,
                readonly: personaReadOnly,
                disabled: false,
                system: false,
                internalValue: personaValue,
                valid: false,
                touched: false,
                multi: false
            } as IUserField,
            {
                displayName: "Ruolo",
                internalName: "ruolo",
                sharepointType: "Choice",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: ruoloValue,
                valid: false,
                touched: false,
                multi: false,
                options: rolesOptions

            } as IChoiceField,
            {
                displayName: "Tipo visibilità",
                internalName: "visibilityType",
                controlType: "dropdown",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: visibilityValue,
                valid: false,
                touched: false,
                multi: true,
                options: [
                    { text: Visibility_Type_Label.get(Visibility_Type.Inoltro), key: Visibility_Type.Inoltro },
                    { text: 'Visibilità', key: Visibility_Type.Visibilita },
                    { text: Visibility_Type_Label.get(Visibility_Type.CopiaConoscenza), key: Visibility_Type.CopiaConoscenza },
                ] as IDropdownOption[]
            } as IChoiceField,
            {
                displayName: "Allegati",
                internalName: "attachment",
                sharepointType: "Yes/No",
                controlType: "boolean",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: attachmentValue,
                valid: false,
                touched: false
            } as IField,
        ];
        setFields(newFields);
    }

    // Click su salva del panel laterale
    const addEditUserSubmit = () => {

        if (checkUserFormValidity()) {
            let user: IUser = fields.find(el => el.internalName === 'utente')?.internalValue[0].user;
            let ruoloId = fields.find(el => el.internalName === 'ruolo')?.internalValue;
            let selectedVisibilityType: Visibility_Type[] = fields.find(el => el.internalName === 'visibilityType')?.internalValue;
            let attachment = fields.find(el => el.internalName === 'attachment')?.internalValue;


            if (props.selectedUor) {

                let ruoliUorContext: IRuoloUor[] = [{
                    userId: user.id,
                    uorId: props.selectedUor!.id!,
                    ruoloId: ruoloId
                }];

                let userNotification: IUserNotifications[] = selectedVisibilityType
                    .map(el => ({
                        userId: user.id,
                        notificationContext: el,
                        uorId: props.selectedUor!.id!,
                        attachment: attachment,
                    }));

                props.onSubmit({ ...user, ruoliUorContext, userNotification });
            }
        }
    }

    const checkUserFormValidity = (): boolean => {

        let isValid = true;


        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        if (newField.internalName === 'utente' && newField.internalValue && newField.internalValue.length > 0 && props.peopleList.findIndex(el => el.userPrincipalName === newField.internalValue[0].user.userPrincipalName) >= 0) {
            toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `L'utente selezionato è già censito in questa UOR`, life: 5000 });
        }
        else if (newField.internalName === 'utente') {
            dismissMessageBar();
        }

        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }



    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditUserSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <Panel
                key='addEditUserPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />
                <div className={"flex flex-column position-relative overflow-hidden"}>
                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            separatorIndexes={[1]}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                            label={"Notifiche Immediate"}
                            labelIndexes={[1]}
                        />


                    </div>
                </div>
                {props.selectedUor && !props.selectedPersona &&
                    < Text variant={'mediumPlus'} styles={textStyles}>Stai aggiungendo l'utente alla UOR "{props.selectedUor.nome}"</Text>}

            </Panel>
        </React.Fragment>

    );
}

export default connector(AddEditUser);
